import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Service } from '../shared/services/service';
import { Funcoes } from "../funcoes";

@Injectable()
export class LabelFotosLaudosTecnicosService extends Service {

  constructor(
    protected http: Http,
    protected func: Funcoes
  ) {
    super();
    this.url = this.dominio + '/adm/laudos-tecnicos/labels-fotos/';
  }

  ordenaLabels(labels) {
    let headers = this.getHeaderLogado();

    return this.http.put(this.url + 'ordenar', JSON.stringify(labels), {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }
}




// WEBPACK FOOTER //
// ./src/app/laudos-tecnicos/label-fotos-laudostecnicos.service.ts